<script type="text/javascript">
import LogInbound from "../../logs/log-inbound";
import AuditTimeline from "../../audit/audit-timeline";

export default {
  components: {AuditTimeline, LogInbound},
  props: {
    transaction: {
      type: String,
      required: true
    },
    object: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      inbound: {
        loading: false,
        item: {}
      },
      item: {
        loading: true,
        item: {
          status: ''
        }
      }
    }
  },
  mounted() {
    this.getItem()
    this.getInbound()
  },
  methods: {
    getItem() {
      this.item.loading = true

      this.$http.get(this.routeUri('hyperion.transaction.show', {
        transaction_uuid: this.transaction
      }) + '?q=')
        .then((response) => this.item.item = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.item.loading = false)
    },
    getInbound() {
      this.inbound.loading = true

      this.$http.get(this.routeUri('hyperion.transaction.inbound', {
        transaction_uuid: this.transaction
      }) + '?q=')
        .then((response) => {
          if (response.data.data.length > 0) {
            this.inbound.item = response.data.data[0]
          }
        })
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.inbound.loading = false)
    }
  }
}
</script>

<template>
  <div>
    <a-row :gutter="16" type="flex" align="middle">
      <a-col :span="6">
        <a-card>
          <a-skeleton :loading="item.loading" active>
            <a-statistic title="Price" :value="item.item.price" :precision="2" groupSeparator="." decimalSeparator=","
                         suffix="IDR" :valueStyle="{color: '#3f8600'}">
              <template v-slot:prefix>
                <a-icon type="arrow-up"/>
              </template>
            </a-statistic>
          </a-skeleton>
        </a-card>
      </a-col>

      <a-col :span="6">
        <a-card>
          <a-skeleton :loading="item.loading" active>
            <a-statistic title="Biller Price" :value="item.item.biller_price" :precision="2" groupSeparator="."
                         decimalSeparator="," suffix="IDR" :valueStyle="{color: '#cf1322'}">
              <template v-slot:prefix>
                <a-icon type="arrow-down"/>
              </template>
            </a-statistic>
          </a-skeleton>
        </a-card>
      </a-col>

      <a-col :span="6">
        <a-card>
          <a-skeleton :loading="item.loading" active>
            <a-statistic title="Profit" :value="item.item.price - item.item.biller_price" :precision="2"
                         groupSeparator="." decimalSeparator="," suffix="IDR"
                         :valueStyle="{color:(item.item.price - item.item.biller_price) > 0 ? '#3f8600' : '#cf1322'}">
              <template v-slot:prefix>
                <a-icon :type="(item.item.price - item.item.biller_price) > 0 ? 'rise' : 'fall'"/>
              </template>
            </a-statistic>
          </a-skeleton>
        </a-card>
      </a-col>
      <a-col :span="6">
        <h1
          :style="{ 'text-align': 'center', 'color': transactionStatusColors[item.item.status]}">
          {{ item.item.status.toUpperCase() }}</h1>
      </a-col>
    </a-row>

    <a-row :gutter="16" style="margin-top: 15px;"
           v-if="(item.item.service_type === 'pay' || item.item.service_type === 'inq')">
      <a-col :span="24">
        <a-alert :type="(item.item.status === 'failed') ? 'error' : item.item.status "
                 :message="item.item.response_text" showIcon/>
      </a-col>
    </a-row>

    <a-row :gutter="16" style="margin-top: 15px;">
      <a-col :span="18">
        <a-card type="inner" size="small" title="Transaction Overview" style="margin-bottom: 15px;">
          Transaction overview
        </a-card>

        <log-inbound :loading="inbound.loading" :item="inbound.item" title="Request Information" :summary="false"/>
      </a-col>
      <a-col :span="6">
        <audit-timeline :id="transaction" :object="object"/>
      </a-col>
    </a-row>
  </div>
</template>
